/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable prettier/prettier */
import groupBy from 'lodash/groupBy';

import type {Xml2Js} from 'interfaces';
import type {Policy} from 'types/general';
import {useAppSelector} from 'store/hooks';
import {hasExactRole} from 'utils';

type TProps = {
	activePolicy: Policy;
	XMLJson: Array<Xml2Js>;
	timeStr: string;
	handleGetTextContent: (arg: Policy, redirect: boolean, edit: boolean) => void;
	onDownloadXML: (arg: Policy) => void;
};

const ActivePolicy = ({
	activePolicy,
	XMLJson,
	timeStr,
	handleGetTextContent,
	onDownloadXML,
}: TProps) => {
	const disabledPolicy =
		activePolicy?.length === 0 || activePolicy?.version === 0;

	const {roles} = useAppSelector(state => state.user);

	const titleCard = !disabledPolicy
		? `${activePolicy?.title} v${activePolicy?.version}`
		: '-';

	const groupXmlData = groupBy(XMLJson, xml => {
		if (xml.$ !== undefined) {
			return xml.$.scope;
		}
	});

	const remapValues = Array.from(
		new Set(
			XMLJson?.flatMap(item =>
				item.transformations?.flatMap(
					(transformation: {ReMap: unknown}) => transformation.ReMap,
				),
			),
		),
	)
		.filter(i => i)
		.map(value => {
			// Comprueba si el valor es un objeto y extrae el campo "_".
			if (typeof value === 'object' && value !== null && '_' in value) {
				return (value as {_: string})._; // Retorna solo el valor de "_".
			}
			return value; // Para cualquier otro tipo de dato, lo retorna tal cual.
		});

	const uniqueRemapValues = Array.from(new Set(remapValues));

	const isReadOnly = hasExactRole(roles, 'policy_engine_read_only');

	return (
		<div className="card-tasks card h-100">
			<div className="card-header">
				<i className="bi bi-filter-square-fill mr-3 float-left text-success bi-2" />
				<h2 className="card-title">Active Policy</h2>
				<p className="card-category">Policy set running right now</p>
			</div>
			<div className="card-body pt-0 mt-n4">
				<div className="d-flex flex-row-reverse mb-1">
					<button
						disabled={disabledPolicy}
						className="border-0 bg-transparent d-inline"
						onClick={() => handleGetTextContent(activePolicy, true, false)}>
						<i
							className={`bi-1 ${isReadOnly ? 'bi-eye' : 'bi-pencil'}`}
							title=""
							data-toggle="tooltip"
							data-original-title="Search"
						/>
					</button>

					<button
						disabled={disabledPolicy}
						className="border-0 bg-transparent d-inline"
						// eslint-disable-next-line no-console
						onClick={() => onDownloadXML(activePolicy)}>
						<i
							className="bi-1 bi-download"
							title=""
							data-toggle="tooltip"
							data-original-title="Download"
						/>
					</button>

					<button
						disabled={disabledPolicy}
						className="border-0 bg-transparent d-inline"
						data-toggle="modal"
						data-target="#modalActivePolicyView">
						<i
							className="bi-1 bi-filetype-xml"
							title=""
							data-toggle="tooltip"
							data-original-title="XML"
						/>
					</button>
				</div>
				<div className="card-body table-responsive p-0">
					<table className="table table-striped table-sm table-head-fixed text-nowrap">
						<thead>
							<tr>
								<th>{activePolicy?.version === 0 ? '-' : titleCard}</th>
							</tr>
						</thead>
						{!disabledPolicy || groupXmlData.Gw?.length ? (
							<tbody>
								<tr>
									<td>Description: {activePolicy?.description}</td>
								</tr>
								<tr>
									<td>{groupXmlData.Gw?.length} Gateway Policies</td>
								</tr>
								<tr>
									<td>
										{groupXmlData.App ? groupXmlData.App?.length : '0'}{' '}
										Application Policies
									</td>
								</tr>
								<tr>
									{uniqueRemapValues?.length ? (
										<td>
											{uniqueRemapValues.length} Mappings used:{' '}
											{uniqueRemapValues.join(', ')}
										</td>
									) : (
										<td>No mappings used</td>
									)}
								</tr>
							</tbody>
						) : (
							<tbody>
								<tr>
									<td colSpan={1} className="text-center">
										No active policy
									</td>
								</tr>
							</tbody>
						)}
					</table>
				</div>
			</div>
			<div className="card-footer">
				<hr />
				<div className="stats">
					<i className="bi-1 bi-clock-history" /> Updated {timeStr}
				</div>
			</div>
		</div>
	);
};

export default ActivePolicy;
